import { useState, useEffect, useCallback } from "react";
import { StyleSheet, View, Text, Platform, Pressable } from "react-native";
import SafeAreaView from "../components/SafeAreaView";
import PageHeader from "../components/PageHeader";
import CustomSwitch from "../components/CustomSwitch";
import { MyAsyncStorage, getSchemeStyle } from "../context/helper";
import { startActivityAsync, ActivityAction } from "expo-intent-launcher";
import Constants from "expo-constants";
//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "../components/VectorIcons";

const SettingScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  const [exportType, setExportType] = useState(true);

  const loadSettings = useCallback(async () => {
    if (Platform.OS === "android") {
      let expType = await MyAsyncStorage.GetBool("exportType", true);
      setExportType(expType);
    }
  }, []);

  const toggleSwitch = async (id, value) => {
    switch (id) {
      case 1: // exporttype
        setExportType(value);
        MyAsyncStorage.SetBool("exportType", value);
        break;
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  return (
    <SafeAreaView style={[styles.mainContainer, schemeStyles.Background]}>
      <PageHeader navigation={navigation} showBack={true} />
      <View style={styles.settContainer}>
        <View style={[styles.headerContainer, schemeStyles.BorderC]}>
          <Text style={[styles.headerText, schemeStyles.grayText]}>
            Einstellungen
          </Text>
        </View>
        {Platform.OS === "android" && (
          <View style={[styles.setSection, schemeStyles.BorderC]}>
            <Text style={[styles.settText, schemeStyles.defaultText]}>
              Benachrichtigungseinstellungen
            </Text>
            <Pressable
              style={styles.setPress}
              onPress={() => {
                //              : "host.exp.exponent",
                startActivityAsync(ActivityAction.APP_NOTIFICATION_SETTINGS, {
                  extra: {
                    "android.provider.extra.APP_PACKAGE":
                      Constants.expoConfig.android.package,
                  },
                });
              }}
            >
              <Ionicons
                name="ellipsis-vertical"
                color={schemeStyles.grayIcon.color}
                size={22}
              />
            </Pressable>
          </View>
        )}
        {Platform.OS === "android" && (
          <View style={[styles.switchSection, schemeStyles.BorderC]}>
            <View style={styles.switchContainer}>
              <Text style={[styles.settText, schemeStyles.defaultText]}>
                Daten Export
              </Text>
              <View style={styles.switch}>
                <View style={styles.switchText}>
                  <Text
                    style={{
                      color: exportType
                        ? schemeStyles.switchColors.greenTextColor
                        : schemeStyles.switchColors.offTextColor,
                    }}
                  >
                    Exportdatei speichern
                  </Text>
                  <Text
                    style={{
                      color: !exportType
                        ? schemeStyles.switchColors.greenTextColor
                        : schemeStyles.switchColors.offTextColor,
                    }}
                  >
                    Exportdatei teilen
                  </Text>
                </View>
                <CustomSwitch
                  onColor={schemeStyles.switchColors.greenOnColor}
                  offColor={schemeStyles.switchColors.greenOnColor}
                  disabledColor={schemeStyles.switchColors.disabledColor}
                  circleActiveColor={
                    schemeStyles.switchColors.circleActiveColor
                  }
                  circleInActiveColor={
                    schemeStyles.switchColors.circleInActiveColor
                  }
                  value={exportType}
                  onValueChange={(val) => {
                    toggleSwitch(1, val);
                  }}
                  disabled={false}
                />
              </View>
            </View>
          </View>
        )}
      </View>
    </SafeAreaView>
  );
};

export default SettingScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  settContainer: {
    marginHorizontal: 10,
  },
  headerContainer: {
    borderBottomWidth: 1,
  },
  headerText: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
  switchSection: {
    borderBottomWidth: 0.5,
  },
  setSection: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    paddingVertical: 20,
  },
  setPress: {
    marginHorizontal: 10,
  },
  switchContainer: {
    flexDirection: "row",
    marginVertical: 10,
    alignItems: "center",
  },
  switchText: {
    marginRight: 10,
  },
  switchTextOn: {
    color: "green",
  },
  switchTextOff: {
    color: "lightgray",
  },
  settText: {
    flex: 1,
    fontSize: 16,
    fontFamily: "Roboto-Regular",
  },
  subText: {
    marginLeft: 20,
  },
  switch: {
    marginRight: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  pickerContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 0.5,
    borderBottomColor: "#ccc",
  },
  picker: {
    width: 130,
  },
  pickerItem: {
    color: "#666666",
  },
  pickerSelItem: {
    color: "#00365a",
  },
  itemDisabled: {
    color: "lightgray",
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
});
